import React, { useCallback, useEffect, useState } from "react";
import { translate } from "../../utils/translations/translate";
import { Label } from "../UI/styles";
import { FilePicker } from "../UI/FilePicker";
import { FileInfo } from "../UI/FileInfo";
import Button from "../UI/Button";
import { Alert } from "../UI/Alert";
import { StyledCardSection } from "./styles";
import { MAX_FILE_SIZE_IN_MB } from "../../utils/constants";
const BUCKET_TO_FIELD_MAPPINGS = {
  msa: "POMSA",
  poWoSOW: "PO_WO_SOW",
  vendorLetter: "VendorLetter",
  coi: "COI",
  other: "OtherAttachments",
};
const ProjectAttachments = ({
  isReadOnlyMode,
  formik,
  projectId,
  onDeleteAttachment,
  toastInfo,
  setToastInfo,
  onToastClose,
}) => {
  const { setFieldValue, values } = formik;
  const { savedAttachments } = values;
  const [attachments, setAttachments] = useState({
    msa: [],
    poWoSOW: [],
    vendorLetter: [],
    coi: [],
    other: [[]],
  });
  const addNewAttachment = () => {
    setAttachments((prev) => {
      return {
        ...prev,
        other: [...prev.other, []],
      };
    });
  };
  const handleDeleteAttachment = async (fieldName, attachmentName) => {
    try {
      const response = await onDeleteAttachment(
        projectId,
        fieldName,
        attachmentName
      );
      return response || false;
    } catch (e) {
      return false;
    }
  };
  const handleFileRemove = (fileIdx, bucket) => {
    if (!attachments[bucket]) return;
    const removeFileFromBucket = () => {
      setAttachments((prev) => {
        const newList = [...prev[bucket]];
        newList.splice(fileIdx, 1);
        return { ...prev, [bucket]: newList };
      });
    };
    const attachmentInfo = attachments[bucket][fileIdx];
    if (attachmentInfo) {
      if (typeof attachmentInfo ?.orignalFile === "string") {
        handleDeleteAttachment(
          BUCKET_TO_FIELD_MAPPINGS[bucket],
          attachmentInfo.orignalFile
        ).then((res) => {
          if (res === true) {
            removeFileFromBucket();
          }
        });
      } else {
        removeFileFromBucket();
      }
    }
  };
  const handleOtherAttachmentsRemove = (baseIndx, fileIdx) => {
    const [otherAttachmentInfo] = attachments.other[baseIndx][fileIdx] || [];
    const removeOtherAttachment = () => {
      setAttachments((prev) => {
        const newAttachements = [...prev.other];
        newAttachements.splice(baseIndx, 1);
        if (newAttachements.length === 0) {
          newAttachements.push([]);
        }
        return { ...prev, other: newAttachements };
      });
    };
    if (
      otherAttachmentInfo &&
      typeof otherAttachmentInfo.orignalFile === "string"
    ) {
      handleDeleteAttachment(
        BUCKET_TO_FIELD_MAPPINGS["other"],
        otherAttachmentInfo.orignalFile
      ).then((res) => {
        if (res === true) {
          removeOtherAttachment();
        }
      });
    } else {
      removeOtherAttachment();
    }
  };
  const handleMaxLimitExceeded = useCallback(() => {
    setToastInfo({
      message: translate("labels.uploadMaxNotification").replace(
        "$maxSize",
        MAX_FILE_SIZE_IN_MB
      ),
      type: "error",
      autoExpire: true,
    });
  }, [setToastInfo]);
  useEffect(() => {
    const filteredAttachments = attachments.other
      .filter((otherAttachment) => otherAttachment.length > 0)
      .map((attachment) => attachment[0][0]);
    setFieldValue(
      "poMsa",
      attachments.msa.length ? attachments.msa[0].orignalFile : null
    );
    setFieldValue(
      "po_wo_sow_",
      attachments.poWoSOW.length ? attachments.poWoSOW[0].orignalFile : null
    );
    setFieldValue(
      "vendorLetter",
      attachments.vendorLetter.length
        ? attachments.vendorLetter[0].orignalFile
        : null
    );
    setFieldValue(
      "coi",
      attachments.coi.length ? attachments.coi[0].orignalFile : null
    );
    setFieldValue(
      "otherAttachments",
      filteredAttachments.length
        ? filteredAttachments.map((file) => file.orignalFile).flat()
        : []
    );
  }, [attachments, setFieldValue]);
  useEffect(() => {
    setAttachments(savedAttachments);
  }, [savedAttachments]);
  return (
    <StyledCardSection>
      {toastInfo && <Alert {...toastInfo} onToastClose={onToastClose} />}
      <h2 className="tma_section-title">{translate("labels.attachments")}</h2>
      <p className="tma_attachments_subtitle">
        {translate("labels.uploadMaxInfo").replace(
          "$maxSize",
          MAX_FILE_SIZE_IN_MB
        )}
      </p>
      <div className="tma-form_field_content tma-form_field_attachments">
        <div className="tma_form-control full_row">
          <div class="attachments_line">
            <Label>{translate("labels.msa")}</Label>
            <div
              className={`fileUpload ${
                attachments.msa ?.length ? "uploaded-file" : ""
            }`}
            >
              <FilePicker
                text={translate("labels.chooseFile")}
                variantStyle="primary"
                type="button"
                id="tma_file_upload_btn_msa"
                className="tma_file_upload_btn"
                disabled={isReadOnlyMode}
                onFileSelection={(files) =>
                  setAttachments((prev) => ({ ...prev, msa: files }))
                }
                onMaxSizeExceeded={handleMaxLimitExceeded}
              />
              <FileInfo
                files={attachments.msa}
                isReadMode={isReadOnlyMode}
                onFileRemove={(fileIdx) => {
                  handleFileRemove(fileIdx, "msa");
                }}
              />
            </div>
          </div>
        </div>

        <div className="tma_form-control full_row">
          <div class="attachments_line">
            <Label>{translate("labels.poWoSOW")}</Label>
            <div
              className={`fileUpload ${
                attachments.poWoSOW ?.length ? "uploaded-file" : ""
            }`}
            >
              <FilePicker
                text={translate("labels.chooseFile")}
                variantStyle="primary"
                className="tma_file_upload_btn"
                type="button"
                id="tma_file_upload_btn_poWoSoW"
                disabled={isReadOnlyMode}
                onFileSelection={(files) =>
                  setAttachments((prev) => ({ ...prev, poWoSOW: files }))
                }
                onMaxSizeExceeded={handleMaxLimitExceeded}
              />
              <FileInfo
                files={attachments.poWoSOW}
                isReadMode={isReadOnlyMode}
                onFileRemove={(fileIdx) => {
                  handleFileRemove(fileIdx, "poWoSOW");
                }}
              />
            </div>
          </div>
        </div>

        <div className="tma_form-control full_row">
          <div class="attachments_line">
            <Label>{translate("labels.vendorLetter")}</Label>
            <div
              className={`fileUpload ${
                attachments.vendorLetter ?.length ? "uploaded-file" : ""
            }`}
            >
              <FilePicker
                text={translate("labels.chooseFile")}
                variantStyle="primary"
                type="button"
                className="tma_file_upload_btn"
                disabled={isReadOnlyMode}
                id="tma_file_upload_btn_vendorLetter"
                onFileSelection={(files) =>
                  setAttachments((prev) => ({ ...prev, vendorLetter: files }))
                }
                onMaxSizeExceeded={handleMaxLimitExceeded}
              />
              <FileInfo
                files={attachments.vendorLetter}
                isReadMode={isReadOnlyMode}
                onFileRemove={(fileIdx) => {
                  handleFileRemove(fileIdx, "vendorLetter");
                }}
              />
            </div>
          </div>
        </div>

        <div className="tma_form-control full_row">
          <div class="attachments_line">
            <Label>{translate("labels.coi")}</Label>
            <div
              className={`fileUpload ${
                attachments.coi ?.length ? "uploaded-file" : ""
            }`}
            >
              <FilePicker
                text={translate("labels.chooseFile")}
                variantStyle="primary"
                className="tma_file_upload_btn"
                disabled={isReadOnlyMode}
                type="button"
                id="tma_file_upload_btn_coi"
                onFileSelection={(files) =>
                  setAttachments((prev) => ({ ...prev, coi: files }))
                }
                onMaxSizeExceeded={handleMaxLimitExceeded}
              />
              <FileInfo
                files={attachments.coi}
                isReadMode={isReadOnlyMode}
                onFileRemove={(fileIdx) => {
                  handleFileRemove(fileIdx, "coi");
                }}
              />
            </div>
          </div>
        </div>

        {attachments.other.map((_, idx, arr) => {
          return (
            <div className="tma_form-control full_row" key={idx}>
              <div class="attachments_line">
                <Label>{translate("labels.otherAttachments")}</Label>
                <div
                  className={`fileUpload ${
                    attachments.other[idx] ?.flat().length ? "uploaded-file" : ""
                }`}
                >
                  <FilePicker
                    text={translate("labels.chooseFile")}
                    variantStyle="primary"
                    className="tma_file_upload_btn"
                    disabled={isReadOnlyMode}
                    type="button"
                    id="tma_file_upload_btn_otherAttachments"
                    acceptMultiple={false}
                    onFileSelection={(files) =>
                      setAttachments((prev) => {
                        const newAttachments = [...prev.other];
                        newAttachments[idx] = [files];
                        return { ...prev, other: newAttachments };
                      })
                    }
                    onMaxSizeExceeded={handleMaxLimitExceeded}
                  />
                  {
                    <FileInfo
                      files={attachments.other[idx] ?.flat()}
                      isReadMode={isReadOnlyMode}
                      onFileRemove={(fileIdx) => {
                        handleOtherAttachmentsRemove(idx, fileIdx);
                      }}
                    />
                  }
                </div>
              </div>
            </div>
          );
        })}
        <div className="tma_form-control"></div>
      </div>
      <div className="tma-form_field_content">
        <div className="tma_form-control">
          <Button
            className={"tma_add_other_files tma_file_upload_btn newattachment"}
            type="button"
            text={translate("labels.newAttachment")}
            variantStyle="primary-outline"
            onClick={addNewAttachment}
          />
        </div>
      </div>
    </StyledCardSection>
  );
};

export default ProjectAttachments;
